interface CookieVariable {
  Key: string;
  Value: string;
}

class _CustomCookieManager {
  private Cookies: CookieVariable[] = [];
  private setCookie = 'set-cookie';
  private setCookieCapital = 'Set-Cookie';
  private ignoreList = ['SameSite=Lax,', 'path=/,'];
  private static _instance: _CustomCookieManager;

  public GetCookies = (headers: any): void => {
    if (headers !== null && headers !== undefined) {
      if (Array.isArray(headers) && headers.length > 0) {
        headers.forEach((h: any) => {
          if (h[this.setCookie]) {
            this.StoreCookies(h[this.setCookie]);
          } else if (h[this.setCookieCapital]) {
            this.StoreCookies(h[this.setCookieCapital]);
          }
        });
      }
      if (headers[this.setCookie]) {
        this.StoreCookies(headers[this.setCookie]);
      } else if (headers[this.setCookieCapital]) {
        this.StoreCookies(headers[this.setCookieCapital]);
      }
    }
  };

  public ClearCookies = (): void => {
    this.Cookies = [];
  };

  private StoreCookies = (str: string): void => {
    let cookies = str;
    this.ignoreList.forEach((l) => {
      cookies = cookies.replace(l, '');
    });
    const separateCookies = cookies.split(';');
    separateCookies.forEach((c) => {
      if (c.indexOf('=') > -1) {
        const splited = c.trim().split('=', 2);
        this.TrySetCookies(splited[0], splited[1]);
      }
    });
  };

  private TrySetCookies = (key: string, value: string): void => {
    if (this.Cookies.findIndex((i) => i.Key === key) > -1)
      this.Cookies = this.Cookies.filter((i) => i.Key !== key);
    this.Cookies.push({ Key: key, Value: value });
  };

  public GiveCookies = (): string => {
    let combined = '';
    this.Cookies.map((c) => (combined += `${c.Key}=${c.Value}; `));
    return combined.slice(0, -2);
  };

  public static Instance() {
    return this._instance || (this._instance = new this());
  }
}

export const CustomCookieManager = _CustomCookieManager.Instance();
